import React from 'react';

const STRANDS = 9;

// Dupla hélice SVG (fitas + pares de bases) nas cores do logo Novo DNA
const Helix = ({ x, scale, opacity, delay }) => {
  const h = 900;
  const pts = (phase) => Array.from({ length: 61 }, (_, i) => {
    const y = (i / 60) * h;
    return `${40 + Math.sin(i / 60 * Math.PI * 4 + phase) * 34},${y}`;
  }).join(' ');
  const rungs = Array.from({ length: 24 }, (_, i) => {
    const t = i / 23;
    const y = t * h;
    const a = 40 + Math.sin(t * Math.PI * 4) * 34;
    const b = 40 + Math.sin(t * Math.PI * 4 + Math.PI) * 34;
    const colors = ['#A574BF', '#22c55e', '#f97316', '#ec4899'];
    return <line key={i} x1={a} y1={y} x2={b} y2={y} stroke={colors[i % 4]} strokeWidth="3" strokeLinecap="round" opacity="0.55" />;
  });
  return (
    <svg viewBox="0 0 80 900" className="dna-bg-helix" preserveAspectRatio="xMidYMid slice"
      style={{ left: `${x}%`, transform: `scale(${scale}) rotate(14deg)`, opacity, animationDelay: `${delay}s` }}>
      {rungs}
      <polyline points={pts(0)} fill="none" stroke="#c084fc" strokeWidth="3" />
      <polyline points={pts(Math.PI)} fill="none" stroke="#4ade80" strokeWidth="3" />
    </svg>
  );
};

export const DnaBackground = () => (
  <div className="dna-bg" aria-hidden="true" data-testid="dna-background">
    <style>{`
      .dna-bg { position: fixed; inset: 0; z-index: 0; overflow: hidden; background: #160a2b; }
      .dna-bg-glow { position: absolute; border-radius: 9999px; filter: blur(90px); opacity: .55; }
      .dna-bg-helix { position: absolute; top: -10%; height: 120%; width: 90px; animation: dnaFloat 14s ease-in-out infinite alternate; }
      .dna-bg-grain { position: absolute; inset: 0; opacity: .08; mix-blend-mode: overlay;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E"); }
      @keyframes dnaFloat { from { translate: 0 -24px; } to { translate: 0 24px; } }
      @media (prefers-reduced-motion: reduce) { .dna-bg-helix { animation: none; } }
    `}</style>
    <div className="dna-bg-glow" style={{ width: 620, height: 620, left: '-8%', top: '-12%', background: '#7B3F98' }} />
    <div className="dna-bg-glow" style={{ width: 460, height: 460, right: '-6%', top: '8%', background: '#ec4899', opacity: 0.35 }} />
    <div className="dna-bg-glow" style={{ width: 520, height: 520, right: '12%', bottom: '-18%', background: '#16a34a', opacity: 0.3 }} />
    <div className="dna-bg-glow" style={{ width: 380, height: 380, left: '18%', bottom: '-14%', background: '#f97316', opacity: 0.28 }} />
    {Array.from({ length: STRANDS }, (_, i) => (
      <Helix key={i} x={i * 11.5 - 2} scale={0.8 + (i % 3) * 0.25} opacity={i % 2 ? 0.14 : 0.24} delay={-i * 1.7} />
    ))}
    <div className="dna-bg-grain" />
  </div>
);
